(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/customer-information.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/customer-information.js');
"use strict";

const {
  UPDATE_CUSTOMERINFO_FORM
} = svs.ticket_partner.physicalTickets.actions;
const {
  DELIVERY_INFO,
  COMPANY_SECTION_HEADER,
  CONTACT_SECTTION_HEADER,
  BILLING_SECTION_HEADER
} = svs.ticket_partner.physicalTickets.constants.FORMS;
const {
  DeliverLatestInput,
  OtherAdressInput,
  MessageInput
} = svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.components;
const {
  AdressInput,
  EmailInput,
  ContactInput,
  CompanyNameInput,
  OrgNrInput,
  CityInput,
  PhoneNrInput,
  ZipCodeInput
} = svs.ticket_partner.sharedComponents.input;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const CustomerInformation = _ref => {
  let {
    dispatch,
    state
  } = _ref;
  const handleInputChange = _ref2 => {
    let {
      target: {
        value,
        id
      }
    } = _ref2;
    dispatch({
      type: UPDATE_CUSTOMERINFO_FORM,
      payload: {
        field: id,
        value
      }
    });
  };
  return React.createElement(Grid, null, React.createElement("h2", null, COMPANY_SECTION_HEADER), React.createElement(GridRow, {
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    am: 8,
    sm: 12
  }, React.createElement(CompanyNameInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(OrgNrInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement("h2", null, CONTACT_SECTTION_HEADER), React.createElement(GridRow, {
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(ContactInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(EmailInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(PhoneNrInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement("h2", null, BILLING_SECTION_HEADER), React.createElement(GridRow, {
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(AdressInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(ZipCodeInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(CityInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 12,
    md: 6,
    sm: 12
  }, React.createElement(DeliverLatestInput, {
    handleChange: handleInputChange,
    state: state
  }), React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement("p", null, DELIVERY_INFO))), React.createElement(GridCol, {
    am: 12,
    md: 6,
    sm: 12
  }, React.createElement(OtherAdressInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 12,
    sm: 12
  }, React.createElement(MessageInput, {
    handleChange: handleInputChange,
    state: state
  }))));
};
svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.CustomerInformation = CustomerInformation;

 })(window);